// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"f81e5ca4","977":"d60d779a"}[chunkId] + ".chunk.js");